<template>
  <div>
    <hg-dialog :title="dType[dialogType]" :width="800" :height="400" :visible="dialogVisible" @close="handleClose">
      <div v-loading="loading">
        <my-content ref="ref" :ruleForm.sync="formData" :dialogType="dialogType"/>
      </div>

      <div slot="footer" style="width:100%;text-align: right">
        <el-button size="small" icon="el-hg-icon-save" type="primary" v-if="dialogType!=='detail'" @click="submit">保 存</el-button>
        <el-button size="small" icon="el-hg-icon-save" type="primary" v-if="dialogType === 'detail'" plain @click="$emit('update:dialogType', 'update')">修 改</el-button>
        <el-button size="small" icon="el-hg-icon-close" type="danger" @click="handleClose">关 闭</el-button>
      </div>
    </hg-dialog>
  </div>
</template>

<script>
import HgDialog from '@/components/dialog';
import MyContent from './content';

export default {
  name: 'MyDialog',
  components: {
    HgDialog,
    MyContent
  },
  props: {
    id: { type: String },
    dialogType: { type: String },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      dType: {
        update: 'echart配置修改',
        detail: 'echart配置详情'
      },
      formData: {}
    };
  },
  methods: {
    async save(param) {
      let params = JSON.parse(JSON.stringify(param));
      this.$services.postJson({
        type: 'ECHARTMANGEMENT',
        url: 'saveEchart', 
        params
      })
      .then(({status}) => {
        if(status){
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.$emit('refresh');
        }
      })
    },
    async getDetail() {
      this.loading = true;
      const { bean } = await this.$services.post({
        type: 'ECHARTMANGEMENT',
        url: 'getDetail',
        params: { id: this.id }
      });
      this.formData = bean;
      this.loading = false;
    },
    submit() {
      let param = this.formData;
      param.updateFlg = 'update';
      this.save(param);
    },
    clearForm() {
      this.formData = {};
    },
    handleClose() {
      this.$confirm('是否不保存离开', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.clearForm();
          this.dialogVisible = false;
          this.$emit('close');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭'
          });
        });
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
        if (this.id) {
          this.getDetail();
        }
      }
      else {
        this.dialogVisible = false;
      }
    }
  }
};
</script>
 <style>

 </style>
